export default __webpack_public_path__ + "static/media/goldengate.a6ed9c53.jpg";